// frontend/src/context/WebSocketContext.jsx

import { createContext, useContext, useCallback } from 'react'
import { useWebSocket } from '../hooks/useWebSocket'

const WebSocketContext = createContext()

export const WebSocketProvider = ({ children }) => {
  const handleMessage = useCallback((message) => {
    // Диспетчируем событие с данными WebSocket
    window.dispatchEvent(
      new CustomEvent('websocket_message', { detail: message })
    )
  }, [])

  const { isConnected, isConnecting, send } = useWebSocket(handleMessage)

  return (
    <WebSocketContext.Provider value={{ isConnected, isConnecting, send }}>
      {children}
    </WebSocketContext.Provider>
  )
}

export const useWebSocketContext = () => {
  const context = useContext(WebSocketContext)
  if (!context) {
    throw new Error('useWebSocketContext must be used within WebSocketProvider')
  }
  return context
}
